import React from 'react';
import { ApolloProvider } from '@apollo/client';

import { createApolloClient } from '../clients';

interface ServerStateProps {
  children: any;
  apiHost: string;
}
export default ({ children, apiHost }: ServerStateProps) => (
  <ApolloProvider client={createApolloClient(apiHost)}>{children}</ApolloProvider>
);
